import axios from "axios";
import config from "config";
import { toast } from "react-toastify";
import axiosInstanceAuth from "./common/axiosInstanceAuth";
import { store } from "index";
import axiosInstance from "./common/axiosInstance";

interface addNewLeadApiType {
  name: string;
  mobile: string;
  email: string;
  address: string;
  latitude: string;
  longitude: string;
  state: string;
  district: string;
  city: string;
  pincode: string;
  services: [string];
  bankname: string;
  bankcode: string;
  leadtype: string;
}

const getTeamsHeaders = () => {
  const { client_id } = store.getState().Lead;
  return {
    "Content-Type": "application/json",
    "client-id": client_id,
  };
};

export const addNewLeadApi = async (data: addNewLeadApiType) => {
  try {
    const response = await axiosInstance.post(
      "/nm/lead/create-public-lead",
      data,
      {
        headers: getTeamsHeaders(),
      }
    );
    console.log(response, "response");
    return response.data;
  } catch (error: any) {
    toast.error(error.response?.data.message, { autoClose: 3000 });
    throw error.response?.data.message || error.message;
  }
};
export const verifyOtpApi = async (data: any) => {
  try {
    console.log("otp api2", data);
    const response = await axiosInstance.post("/nm/lead/verify-lead-otp", data);
    console.log(response, "response");
    return response;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
export const resendOtpApi = async (data: any) => {
  try {
    console.log("otp api2", data);
    const response = await axiosInstance.post("/nm/lead/resend-lead-otp", data);
    console.log(response, "response");
    return response;
  } catch (error: any) {
    toast.error(error.message, { autoClose: 3000 });
    throw error.response?.data || error.message;
  }
};

export const getClientDataApi = async (params: Record<string, any>) => {
  try {
    const response = await axiosInstanceAuth.get("/auth/vendordata", {
      params,
    });
    console.log("Response", response);
    return response.data;
  } catch (error: any) {
    console.log("Error", error);
    throw error.response?.data || error.message;
  }
};
